import {compose, pure, mapProps} from 'recompose'

import {classNames, withTheme} from '@base/react-utils'
import {
  ThemeableComponentProps,
  ThemeableProps,
} from '@base/react-utils/themeable'
import withFocusedState from '@base/react-utils/withFocusedState'

import SearchInput from '@base-uikit/inputs/SearchInput'
import withFiltering, {
  withFilteringState,
} from '@base-uikit/lists/behaviours/withFiltering'
import withKeyboardNavigation, {
  withKeyboardNavigationState,
} from '@base-uikit/lists/behaviours/withKeyboardNavigation'
import NoResultsInfo from '@base-uikit/lists/NoResultsInfo'
import type {VirtualListItemsProps} from '@base-uikit/lists/VirtualList'
import type {SizeProps} from '@base-uikit/styles/grid'

import withSelectController from '../SelectController/withSelectController'
import type {SelectControllerProps} from '../SelectController/withSelectController'
import renderList from './renderList'

import baseTheme from './ListSelect.css'

export interface ListSelectProps
  extends SizeProps,
    VirtualListItemsProps,
    SelectControllerProps,
    ThemeableComponentProps {
  className?: string
}

const ListSelect: (
  a: ListSelectProps
) => React.ReactElement<React.ComponentType<ListSelectProps>> = compose<
  any,
  any
>(
  pure,
  withTheme(baseTheme),
  mapProps((props: ListSelectProps & ThemeableProps) => ({
    filterInput: SearchInput,
    noResultsComponent: NoResultsInfo,
    ...props,
    className: classNames(props.theme.ListSelect, props.className),
  })),
  withFilteringState(),
  withKeyboardNavigationState(),
  withFocusedState(),
  withFiltering(),
  withSelectController({
    multiple: false,
  }),
  withKeyboardNavigation()
)((props) => {
  return renderList(props)
}) as any

// @ts-ignore
ListSelect.displayName = 'ListSelect'

export default ListSelect
